import { combineReducers } from 'redux'
import slideshowData from './slideshowData'

export default combineReducers({
  slideshowData,
})
